import { _isObjEmpty, toTestId } from '@aw/lib'
import Notification from '../../notification'

export type FormErrorProps = {
    state: {
        message?: string
        errors?: Record<string, string>
    }
    className?: string
    /**
     * AWOPS-3496 — automation hook. Lands on the error Notification, and each per-field
     * bullet becomes `{testId}-{field}` so a negative-path test can assert the message
     * for a specific field instead of scraping the whole block.
     */
    testId?: string
}


function FormErrors({ state, className, testId }: FormErrorProps) {
    return (
        state?.message ? (
            <Notification
                testId={testId}
                variant="error"
                className={className}
                description={state?.message || 'Whoops! Something went wrong.'}
            >
                {state?.errors && !_isObjEmpty(state?.errors) && Object.keys(state?.errors).length > 1 && (
                    <ul className="mt-1 list-inside list-disc text-sm first-letter:capitalize">
                        {Object.entries(state?.errors).map(([field, msg]) => (
                            <li key={field} data-testid={testId ? `${testId}-${toTestId(field)}` : undefined}>{JSON.stringify(msg)}</li>
                        ))}
                    </ul>
                )}
            </Notification>
        ) : <></>
    )
}

export default FormErrors